export const APPLICATION_SETTING_FIXTURES = {
    id: null,
    ldapUrl: '123',
    domain: '123',
    minUserIdLength: 8,
    maxUserIdLength: 25,
    allowedCharacters: 'A–Z, a–z, 0–9, _ . -',
    caseSensitive: 0,
    allowedSpaceNumber: 0,
    userIdBlacklists: [
        { id: 0, code: 'K01', createDate: '2024/01/01', updateDate: '2026/03/03', status: 1 },
        { id: 0, code: 'K02', createDate: '2024/01/01', updateDate: '2026/03/03', status: 1 }
    ],
    minPasswordLength: 8,
    maxPasswordLength: 30,
    upperCaseRequired: 0,
    numericRequired: 0,
    specialCharacterRequired: 0,
    lowerCaseRequired: 0,
    disAllowUsernameInPassword: 0,
    spaceAllow: 0,
    maxConsecutiveIdenticalCharacters: 1,
    maxSequentialCharacters: null,
    passwordGenerationMethod: 3,
    defaultPassword: '123',
    passwordHistory: 'Last 10',
    userBlacklistPasswords: [
        { id: 0, code: 'K01', createDate: '2024/01/01', updateDate: '2026/03/03', status: 1 },
        { id: 0, code: 'K02', createDate: '2024/01/01', updateDate: '2026/03/03', status: 1 }
    ],
    forceChangeForNewUser: 0,
    forceChangeAfterReset: 0,
    expiredPassword: '90 days',
    expiredWarning: '14 days',
    inactiveAccountDisable: '90 days',
    maxFailedAttempts: 5,
    temporaryLock: '15 minutes',
    permanentLock: 'After 10 failures',
    sessionTimeOut: '15 minutes',
    absoluteSessionTimeOut: '8 hours',
    defaultAccessDateFrom: new Date(),
    defaultAccessDateTo: new Date(),
    defaultAccessTimeFrom: new Date(),
    defaultAccessTimeTo: new Date(),
    forceLogoutOnPasswordChange: 1,
    forceLogoutOnRoleChange: 1,
    approvalRequired: 1,
    allowSelfApproval: 1,
    systemLogoPath: null,
    reportLogoPath: null,
    systemDateFormat: 'DD-MM-YYYY',
    systemTimeFormat: '12 hour format',
    watchlistProviderSetting: 'Dow Jones',
    extractionDownloadSetting: null,
    uploadFileSize: 6000
};
